export default async function useGetShopwarePageByUrl(slug: string) {
    const encodedSlug = encodeURIComponent(slug);
    const { apiClient } = useShopwareContext();

    // useAsyncData serializes the SSR result into the Nuxt payload so the
    // client doesn't refetch the same page during hydration. This prevents
    // category data (and the H1/SEO context derived from it) from briefly
    // disappearing while the duplicate client request is in flight.
    const { data } = await useAsyncData(`shopware-page:${encodedSlug}`, async () => {
        const response = await apiClient.invoke('readPage post /nd/frontend/url?url={url}', {
            body: { url: encodedSlug },
            pathParams: { url: encodedSlug },
        });
        return response.data;
    });

    return { data: data.value };
}
